module.exports = __webpack_public_path__ + "img/feedback6.fa719118.webp";